import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loading: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Allow opt-out per request: headers: { 'X-Skip-Loader': 'true' }
    const skip = req.headers.get('X-Skip-Loader') === 'true';

    if (!skip) this.loading.show();

    return next.handle(req).pipe(
      finalize(() => {
        if (!skip) this.loading.hide();
      })
    );
  }
}
